import React from 'react';

const INPUT_CLASS =
  'w-full bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-xl py-3 px-4 text-sm text-[var(--text-main)] placeholder-[var(--text-secondary)]/50 focus:outline-none focus:border-brand-green focus:ring-1 focus:ring-brand-green transition-all';

export default function TimestampInput({ className = '', ...props }) {
  return (
    <input
      type="text"
      inputMode="numeric"
      placeholder="mm:ss"
      className={`${INPUT_CLASS} ${className}`}
      {...props}
    />
  );
}
